// Lightweight EN/ES i18n. Keys ARE the English strings — untranslated keys fall
// through to English, so new UI never breaks and ES coverage grows string by
// string (walk-through observations land here as one-line additions).
const ES = {
  // shell
  Projects: 'Proyectos',
  'My Work': 'Mi Trabajo',
  Calendar: 'Calendario',
  Time: 'Tiempo',
  'Check-ins': 'Reportes diarios',
  Workloads: 'Cargas de trabajo',
  Reports: 'Informes',
  Search: 'Buscar',
  Notifications: 'Notificaciones',
  'Sign out': 'Cerrar sesión',
  'Signed in': 'Sesión iniciada',

  // login
  'Project management': 'Gestión de proyectos',
  'Username or email': 'Usuario o correo',
  Password: 'Contraseña',
  'Sign in': 'Entrar',
  'Signing in…': 'Entrando…',
  'Login failed': 'Error de acceso',
  'Signing you in…': 'Iniciando tu sesión…',
  'SSO sign-in failed': 'Error de acceso por SSO',
  'Missing SSO token': 'Falta el token de SSO',
  'Go to sign in': 'Ir al inicio de sesión',
  operator: 'operador',
  contributor: 'colaborador',
  admin: 'administrador',
  member: 'miembro',

  // shares / duties (Phase 3-4)
  'Last brief published': 'Último brief publicado',
  'none yet': 'ninguno aún',
  'Share this content': 'Comparte este contenido',
  Remove: 'Quitar',
  'Scheduled for': 'Programado para',
  'Share on': 'Compartir en',
  'share(s) recorded': 'compartido(s) registrado(s)',
  'Attach content to share': 'Adjuntar contenido para compartir',
  'Search articles, news, briefs…': 'Buscar artículos, noticias, briefs…',
  'Suggested message (optional)': 'Mensaje sugerido (opcional)',
  Attribution: 'Atribución',
  'Member default': 'Según el perfil del miembro',
  'With referral code': 'Con código de referido',
  'Name only (no code)': 'Solo nombre (sin código)',
  'Schedule (optional)': 'Programar (opcional)',
  Back: 'Volver',
  'Access is limited to attached members during development.':
    'El acceso está limitado a miembros autorizados durante el desarrollo.',

  // portfolio
  'New project': 'Nuevo proyecto',
  Archived: 'Archivados',
  'Showing archived': 'Mostrando archivados',
  Favorites: 'Favoritos',
  Other: 'Otros',
  'No archived projects.': 'No hay proyectos archivados.',
  'No projects yet — create the first one.': 'Aún no hay proyectos — crea el primero.',
  Name: 'Nombre',
  'Description (optional)': 'Descripción (opcional)',
  'Folder (optional)': 'Carpeta (opcional)',
  'No folder': 'Sin carpeta',
  'Start from': 'Comenzar desde',
  'Blank project': 'Proyecto en blanco',
  Cancel: 'Cancelar',
  'Creating…': 'Creando…',
  'Create project': 'Crear proyecto',
  tasks: 'tareas',

  // project tabs
  Tasks: 'Tareas',
  Roadmap: 'Cronograma',
  Discussion: 'Discusión',
  Docs: 'Documentos',
  Files: 'Archivos',
  Forms: 'Formularios',
  Report: 'Informe',
  Activity: 'Actividad',
  Settings: 'Configuración',
  Archive: 'Archivar',
  Unarchive: 'Desarchivar',
  'All projects': 'Todos los proyectos',
  'Project not found.': 'Proyecto no encontrado.',
  'Back to projects': 'Volver a proyectos',

  // tasks toolbar + views
  Board: 'Tablero',
  List: 'Lista',
  Timeline: 'Cronograma',
  'All assignees': 'Todos los asignados',
  'All labels': 'Todas las etiquetas',
  'Add group': 'Añadir grupo',
  'Add task': 'Añadir tarea',
  'Add task group': 'Añadir grupo de tareas',
  'Group name': 'Nombre del grupo',
  'Task title, Enter to add': 'Título de la tarea, Enter para añadir',
  'No tasks.': 'Sin tareas.',
  selected: 'seleccionadas',
  Complete: 'Completar',
  'Move to…': 'Mover a…',
  Delete: 'Eliminar',
  Clear: 'Limpiar',

  // task panel
  'Mark complete': 'Marcar completada',
  Completed: 'Completada',
  'Start date': 'Fecha de inicio',
  'Due date': 'Fecha límite',
  Priority: 'Prioridad',
  Assignees: 'Asignados',
  Operators: 'Operadores',
  Contributors: 'Colaboradores',
  Team: 'Equipo',
  Unassigned: 'Sin asignar',
  'No assignable members': 'No hay miembros asignables',
  Milestone: 'Hito',
  'No milestone': 'Sin hito',
  Repeats: 'Se repite',
  Never: 'Nunca',
  Daily: 'Diario',
  Weekly: 'Semanal',
  Monthly: 'Mensual',
  'Blocked by': 'Bloqueada por',
  Labels: 'Etiquetas',
  Description: 'Descripción',
  'Add a description…': 'Añade una descripción…',
  Subtasks: 'Subtareas',
  'Add subtask': 'Añadir subtarea',
  Comments: 'Comentarios',
  'No comments yet.': 'Aún no hay comentarios.',
  'Write a comment…': 'Escribe un comentario…',
  Track: 'Cronometrar',
  Stop: 'Detener',

  // my work
  'Assigned to me': 'Asignadas a mí',
  'Created by me': 'Creadas por mí',
  Watching: 'Siguiendo',
  Overdue: 'Vencidas',
  'Due this week': 'Vencen esta semana',
  Later: 'Más adelante',
  'No date': 'Sin fecha',
  'Nothing here — enjoy the calm.': 'Nada por aquí — disfruta la calma.',

  // time
  Total: 'Total',
  Billable: 'Facturable',
  Entries: 'Registros',
  'All people': 'Todas las personas',
  Date: 'Fecha',
  Person: 'Persona',
  Project: 'Proyecto',
  Task: 'Tarea',
  Note: 'Nota',
  Hours: 'Horas',
  'No time entries — start a timer from any task panel.':
    'Sin registros de tiempo — inicia un cronómetro desde cualquier tarea.',

  // misc shared
  Today: 'Hoy',
  Save: 'Guardar',
  Edit: 'Editar',
  Create: 'Crear',
  'Load more': 'Cargar más',
  'Loading…': 'Cargando…',
  'No activity yet.': 'Aún no hay actividad.',
  'No messages yet — start the discussion.': 'Aún no hay mensajes — inicia la discusión.',
  'Load older messages': 'Cargar mensajes anteriores',
  'No docs yet.': 'Aún no hay documentos.',
  'No forms yet.': 'Aún no hay formularios.',
  'New form': 'Nuevo formulario',
  'New milestone': 'Nuevo hito',
  'New milestone name': 'Nombre del nuevo hito',
  Status: 'Estado',
  'Group by': 'Agrupar por',
  'No grouping': 'Sin agrupar',
  'Group by status': 'Agrupar por estado',
  'Search people…': 'Buscar personas…',
  'Show all': 'Ver todos',
  'All Operators': 'Todos los operadores',
  'All Contributors': 'Todos los colaboradores',
  'No matches': 'Sin coincidencias',
  'No one assigned — search or Show all': 'Nadie asignado — busca o pulsa Ver todos',
  'Time tracked': 'Tiempo registrado',
  'Start timer': 'Iniciar temporizador',
  'Stop timer': 'Detener temporizador',
  'New check-in': 'Nuevo reporte',
  'No milestones yet.': 'Aún no hay hitos.',
  'Upload files': 'Subir archivos',
  // MMS_POINTS_HUB_PLAN F5 — Points tab
  "Points": "Puntos",
  "What your work in projects earns you.": "Lo que te da tu trabajo en los proyectos.",
  "Earned in projects": "Ganados en proyectos",
  "Total balance": "Saldo total",
  "Across every product, in My Account": "De todos los productos, en My Account",
  "Tasks completed": "Tareas completadas",
  "shares": "compartidos",
  "How to earn points here": "Cómo ganar puntos aquí",
  "Every action below adds points to your balance. Points are awarded a few seconds after the action.": "Cada acción de esta lista suma puntos a tu saldo. Los puntos llegan unos segundos después de la acción.",
  "No point actions are active in the PMS right now.": "Ahora mismo no hay acciones con puntos activas en el PMS.",
  "Action": "Acción",
  "Limits": "Límites",
  "Done": "Hechas",
  "Latest points": "Últimos puntos",
  "Complete a task to earn your first points here.": "Completa una tarea para ganar tus primeros puntos aquí.",
  "once each": "una vez cada uno",
  "up to": "hasta",
  "per day": "al día",
  "in total": "en total",
  "Points are not available right now. Try again in a moment.": "Los puntos no están disponibles ahora. Inténtalo en un momento.",
  "Complete a task": "Completar una tarea",
  "Your assigned task was completed": "Se completó una tarea asignada a ti",
  "Share content (PMS task)": "Compartir contenido (tarea del PMS)",
  "Times": "Veces",
  "per purchase": "por compra",
};

const LANG_KEY = 'pms_lang';

export function getLang() {
  return localStorage.getItem(LANG_KEY) === 'es' ? 'es' : 'en';
}

export function setLang(lang) {
  localStorage.setItem(LANG_KEY, lang === 'es' ? 'es' : 'en');
  window.location.reload(); // simple + safe: strings are read at render time everywhere
}

export function t(key) {
  if (getLang() === 'es') return ES[key] || key;
  return key;
}
